import { FormikProps } from 'formik';
import { FormValues } from '../types';
import { Box, IconButton, SxProps, Typography } from '@mui/material';
import { ClosingMethod } from 'services/campaign/types';
import CloseIcon from '@mui/icons-material/Close';
import {
  AutomationActionType,
  RequirementConditionType
} from 'services/automation/types';
import { CandidateStatusItem } from './CandidateStatusItem';
import { Dropdown } from 'components/DropDown';
import { UploadDocumentItem } from './UploadDocumentItem';
import { getAutomationTypesOptions } from '../utils/getAutomationTypesOptions';
import { ConversationStatus } from 'generated-graphql/types';

const container: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

type Props = {
  formik: FormikProps<FormValues>;
  index: number;
  closingMethod: ClosingMethod;
  removeAutomationItem: () => void;
  conversationStatusAvailableOptions: ConversationStatus[];
  actionOptionsAvailable: AutomationActionType[];
  atsJobId: string | null | undefined;
  atsListId: string | null | undefined;
  documentTypesAvailableOptions: string[];
};

export const AutomationItem: React.FC<Props> = ({
  formik,
  index,
  closingMethod,
  removeAutomationItem,
  conversationStatusAvailableOptions,
  actionOptionsAvailable,
  documentTypesAvailableOptions,
  atsJobId,
  atsListId
}) => {
  const automationTypeOptions = getAutomationTypesOptions({
    documentTypesAvailableOptions,
    atsJobId,
    atsListId
  });

  const automationType =
    formik.values[index].requirementConditions[0].type || '';

  return (
    <Box sx={container}>
      <Typography>When a candidate</Typography>

      <Box minWidth={160}>
        <Dropdown
          options={automationTypeOptions}
          onChange={(value) => {
            formik.setFieldValue(
              `[${index}].requirementConditions[0].type`,
              value
            );
          }}
          value={automationType}
        />
      </Box>

      {automationType ===
        RequirementConditionType.CONVERSATION_STATUS_CONDITION && (
        <CandidateStatusItem
          formik={formik}
          index={index}
          atsJobId={atsJobId}
          closingMethod={closingMethod}
          conversationStatusAvailableOptions={
            conversationStatusAvailableOptions
          }
          actionOptionsAvailable={actionOptionsAvailable}
        />
      )}

      {automationType ===
        RequirementConditionType.CONVERSATION_DOCUMENT_UPLOAD_CONDITION && (
        <UploadDocumentItem formik={formik} index={index} />
      )}
      <Box>
        <IconButton onClick={removeAutomationItem} color="primary">
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
